import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ExecuteCancelDialog,
  type ExecuteCancelDialogProps,
} from '~/components/elements/ExecuteCancelDialog'
import { StyledInput } from '~/components/elements/StyledInput'
import { exists } from '~/utils'

import { useAtomContext } from '../providers/AtomsProvider'

export const EditGroupNameDialog = () => {
  const { t } = useTranslation()
  const [nameEditingGroup, setNameEditingGroup] =
    useAtomContext('nameEditingGroup')
  const [groupNameMap, setGroupNameMap] = useAtomContext('groupNameMap')
  const [name, setName] = React.useState(
    exists(nameEditingGroup) ? groupNameMap[nameEditingGroup] : '',
  )

  const handleCancel = React.useCallback<
    EH<ExecuteCancelDialogProps, 'onCancel'>
  >(() => {
    setNameEditingGroup(null)
  }, [setNameEditingGroup])

  const handleExecute = React.useCallback<
    EH<ExecuteCancelDialogProps, 'onExecute'>
  >(() => {
    setGroupNameMap(
      exists(nameEditingGroup)
        ? {
            ...groupNameMap,
            [nameEditingGroup]: name,
          }
        : groupNameMap,
    )
    setNameEditingGroup(null)
  }, [
    setGroupNameMap,
    nameEditingGroup,
    groupNameMap,
    name,
    setNameEditingGroup,
  ])

  return (
    <ExecuteCancelDialog
      disabledExecute={name.length === 0}
      mode="update"
      title={t('update_group_name')}
      onCancel={handleCancel}
      onExecute={handleExecute}
    >
      <StyledInput value={name} width="100%" onValueChange={setName} />
    </ExecuteCancelDialog>
  )
}
